// import React from "react";
// import "../privacypolicy/Privacypolicy.css";
// import { Link } from "react-router-dom";
// import Header from "../header/header";
// import Footer from "../footer/footer";

// const TermsAndConditions = () => {
//   return (
//     <div>
//       <Header />
//       <div className="terms-page">
//         <h4>AstroBhagya – Terms & Conditions</h4>
//         <p>
//           <b>AstroBhagya App</b>, developed and managed by{" "}
//           <b>Heavenly Expectation Private Limited</b>, offers trusted astrology
//           services and personalized guidance in a modern digital format.
//         </p>
//         <h5>1. Introduction / Agreement</h5>
//         <p>
//           Welcome to AstroBhagya. AstroBhagya (“AstroBhagya,” “we,” “us” or
//           “our”) is an online platform through which users can connect with
//           qualified astrologers to obtain astrology consultations primarily via
//           real-time chat and telephone calls. The Platform facilitates secure
//           booking, payment processing and communication between users and
//           astrologers, and may from time to time offer related content, reports
//           or additional services.
//         </p>
//         <p>
//           These Terms & Conditions (“Terms”) govern your access to and use of
//           the Platform, including our website, mobile application, and any
//           content, functionality, products, or services offered through it. By
//           accessing, browsing, downloading, or using the Platform in any manner,
//           you acknowledge that you have read, understood, and agreed to be bound
//           by these Terms and our Privacy Policy (incorporated herein by
//           reference). If you do not agree to all of these Terms, you must
//           immediately discontinue use of the Platform.
//         </p>
//         <p>
//           We reserve the right to update, revise, or replace these Terms at any
//           time, without prior notice, at our sole discretion. The date of the
//           latest revision is indicated at the top of this page. It is your
//           responsibility to review these Terms periodically for changes. Your
//           continued use of the Platform after posting of any revised Terms
//           constitutes your acceptance of the updated Terms.
//         </p>
//         <p>
//           The Platform is intended for users located in India, but it may be
//           accessible to users outside India as well. All services, charges, and
//           policies are subject to the laws and regulations of India.
//         </p>

//         <h5>2. Definitions</h5>
//         <p>
//           For purposes of these Terms, the following words and expressions shall
//           have the meanings set out below. These definitions are intended to
//           clarify, not to limit, the scope of these Terms:
//         </p>
//         <ul>
//           <li>
//             <strong>
//               “AstroBhagya” / “we” / “us” / “our” / “the Platform”:
//             </strong>{" "}
//             Refers to the legal entity operating the online platform, including
//             its employees, directors, officers, agents, successors, and assigns.
//           </li>
//           <li>
//             <strong>“User” / “you” / “your”:</strong> Any individual or entity
//             who accesses, registers on, browses, or uses the Platform or any of
//             its services, whether or not they create an account or make a
//             payment.
//           </li>
//           <li>
//             <strong>“Astrologer” / “Service Provider”:</strong> Any verified
//             practitioner, consultant, or expert in astrology or related fields
//             who offers consultation, advice, or other services through the
//             Platform to Users. This includes individuals engaged by AstroBhagya
//             on a contractual or freelance basis.
//           </li>
//           <li>
//             <strong>“Services”:</strong> All services, features, and functions
//             provided or facilitated by AstroBhagya through the Platform. This
//             includes but is not limited to: live chat consultations, audio/video
//             calls, personalized horoscope reports, birth chart analyses,
//             remedial suggestions, and any other astrology-related content or
//             products.
//           </li>
//           <li>
//             <strong>“Account”:</strong> The personal profile created by a User
//             or Astrologer upon registration on the Platform, which contains
//             information such as name, contact details, birth details, payment
//             information, and consultation history.
//           </li>
//           <li>
//             <strong>“Content”:</strong> Any text, images, videos, audio, data,
//             graphics, or other materials uploaded, transmitted, or made
//             available through the Platform, whether by AstroBhagya, Users, or
//             Astrologers.
//           </li>
//           <li>
//             <strong>“Privacy Policy”:</strong> The separate policy statement
//             published by AstroBhagya that explains how we collect, use, and
//             protect Users’ personal data.
//           </li>
//           <li>
//             <strong>“Applicable Law”:</strong> All statutes, regulations, rules,
//             ordinances, notifications, and other legal instruments in force in
//             India and, where relevant, in other jurisdictions.
//           </li>
//         </ul>

//         <h5>3. Scope of Services</h5>

//         <strong>3.1 Nature of the Platform</strong>
//         <p>
//           AstroBhagya is an intermediary platform designed to facilitate online
//           astrology consultations and related services between users (“Users”)
//           and independent practitioners of astrology and associated disciplines
//           (“Astrologers”). We provide a secure technological interface and
//           administrative support so that Users can easily discover, book and pay
//           for consultations with Astrologers. The Platform is a marketplace and
//           communications tool; we are not the employer of Astrologers and do not
//           directly provide astrology services ourselves.
//         </p>

//         <strong>3.2 Core Services Offered</strong>
//         <p>
//           Without limitation, the main services currently provided on the
//           Platform include:
//         </p>
//         <ul>
//           <li>
//             <strong>Live Consultations:</strong> Real-time chat sessions and
//             audio or telephone calls with Astrologers for personal astrological
//             guidance.
//           </li>
//           <li>
//             <strong>Written Reports:</strong> Personalised horoscope analyses,
//             compatibility assessments, and remedial suggestions delivered in
//             written or digital form.
//           </li>
//           <li>
//             <strong>Knowledge Resources:</strong> Access to articles, blogs,
//             videos and other educational materials on astrology, vastu and
//             related topics curated or facilitated by AstroBhagya.
//           </li>
//           <li>
//             <strong>Astrologer Dashboard:</strong> Digital tools enabling
//             Astrologers to manage their profiles, schedules, appointments,
//             communications and payments.
//           </li>
//         </ul>
//         <p>
//           We may from time to time introduce new features, services or products,
//           or modify or discontinue existing ones, at our discretion.
//         </p>

//         <strong>3.3 Verification of Astrologers</strong>
//         <p>
//           We strive to ensure that only verified and competent Astrologers are
//           listed on the Platform. Verification may include identity checks,
//           background screening, Aadhaar verification, police verification,
//           sample consultations and collection of references. However, the
//           listing of an Astrologer on the Platform does not constitute a
//           warranty or endorsement of that individual’s qualifications,
//           experience, competence, integrity or accuracy of advice. All services
//           provided by Astrologers are offered in their personal capacity as
//           independent service providers.
//         </p>
//         <strong>3.4 Independence of Advice</strong>
//         <p>
//           AstroBhagya does not control, direct or influence the substance of any
//           consultation, report or other service provided by an Astrologer. All
//           such advice represents the independent opinion of the Astrologer and
//           does not constitute a recommendation, endorsement or guarantee by
//           AstroBhagya. Any reliance on such advice is solely at your own
//           discretion and risk.
//         </p>

//         <strong>3.5 Limitations of Services</strong>
//         <p>You acknowledge and agree to the following limitations:</p>
//         <ul>
//           <li>
//             <strong>Informational Nature:</strong> Services provided through the
//             Platform are intended solely for informational, entertainment and
//             guidance purposes. They should not be considered a substitute for
//             professional advice in medical, legal, financial, psychological or
//             other specialised fields.
//           </li>
//           <li>
//             <strong>No Guarantee of Accuracy or Effectiveness:</strong> The
//             accuracy, reliability or effectiveness of any prediction,
//             suggestion, remedy or product cannot be guaranteed. Outcomes may
//             vary depending on individual circumstances and no particular result
//             is promised.
//           </li>
//           <li>
//             <strong>Remedies and Products:</strong> Any remedial products,
//             rituals or recommendations offered by Astrologers (such as
//             gemstones, mantras, poojas or astrological remedies) are to be
//             undertaken at your own discretion and risk. AstroBhagya is not
//             responsible for the effectiveness, side-effects, authenticity or
//             safety of such remedies or products.
//           </li>
//           <li>
//             <strong>Third-Party Services:</strong> Where an Astrologer refers
//             you to or sells you products or services from a third party, such
//             dealings are solely between you and that third party. AstroBhagya is
//             not a party to, and does not accept liability for, such
//             transactions.
//           </li>
//         </ul>

//         <strong>3.6 Eligibility and Account Requirements</strong>
//         <p>
//           To access services on the Platform, Users and Astrologers must create
//           an account and provide accurate, current and complete information. You
//           are responsible for maintaining the confidentiality of your login
//           credentials and for all activities that occur under your account. The
//           Platform may impose minimum age or other eligibility criteria as
//           required by law.
//         </p>

//         <strong>3.7 Payments and Pricing</strong>
//         <p>
//           AstroBhagya facilitates payment processing between Users and
//           Astrologers. Charges for consultations, reports or other services will
//           be displayed on the Platform. Payments are processed through secure
//           payment gateways. AstroBhagya may deduct its commission or service
//           fees before remitting balances to Astrologers. Taxes such as GST will
//           be applied as required by applicable law. Refunds, if any, are
//           governed by our Refund Policy.
//         </p>

//         <strong>3.8 Quality and Feedback</strong>
//         <p>
//           We may allow Users to rate or review Astrologers and their services to
//           promote transparency. Ratings and reviews reflect the opinion of
//           individual Users and do not constitute endorsements by AstroBhagya. We
//           reserve the right to moderate, remove or edit reviews that violate our
//           policies.
//         </p>
//         <strong>3.9 User Conduct on the Platform</strong>
//         <p>
//           Users must not misuse the Platform. Prohibited conduct includes but is
//           not limited to: abusive or offensive language towards Astrologers or
//           staff, attempts to solicit services outside the Platform, sharing
//           false information, or nudity images, infringing intellectual property,
//           uploading harmful content or engaging in fraudulent or illegal
//           activities. We reserve the right to suspend or terminate accounts for
//           violations.
//         </p>

//         <strong>3.10 Intellectual Property in Platform Content</strong>
//         <p>
//           All content created or provided by AstroBhagya, including the website,
//           mobile application, user interfaces, branding, design, software,
//           articles and educational resources, is owned by or licensed to
//           AstroBhagya and protected under applicable intellectual property laws.
//           Users are granted a limited, non-exclusive, non-transferable licence
//           to access and use such content solely for personal, non-commercial
//           purposes.
//         </p>

//         <strong>3.11 Service Availability and Technical Issues</strong>
//         <p>
//           We endeavour to keep the Platform available and functioning smoothly.
//           However, we do not guarantee uninterrupted access and may suspend or
//           restrict access for maintenance, upgrades, security reasons or
//           circumstances beyond our control. We will use reasonable efforts to
//           notify Users of planned downtime where practicable.
//         </p>

//         <strong>3.12 Modifications to Services</strong>
//         <p>
//           AstroBhagya may at any time, without liability, add, remove or alter
//           any aspect of the Platform or its services, including features,
//           pricing and availability, to reflect changes in law, technology,
//           business needs or user demand. Continued use of the Platform following
//           such changes constitutes acceptance of them.
//         </p>

//         <strong>3.13 Disclaimer of Responsibility for Content</strong>
//         <p>
//           Content provided on or through the Platform by Astrologers or other
//           Users is their own responsibility. While we may implement moderation
//           or quality-control measures, we are not obliged to monitor all content
//           and disclaim any liability for errors, omissions or unlawful material
//           posted by third parties.
//         </p>

//         <strong>3.14 Third-Party Links and Integrations</strong>
//         <p>
//           The Platform may contain links to, or integrate with, third-party
//           websites, applications or services. Such links or integrations are
//           provided for convenience only. We do not endorse or assume
//           responsibility for the content, privacy practices or availability of
//           third-party services. Your use of them is at your own risk and subject
//           to the relevant third party’s terms and conditions.
//         </p>

//         <strong>3.15 Limitation of Liability</strong>
//         <p>
//           To the fullest extent permitted by law, AstroBhagya shall not be
//           liable for any loss, damage or injury arising out of or in connection
//           with: (i) reliance on advice or predictions provided by Astrologers;
//           (ii) the purchase or use of any remedial product or recommendation;
//           (iii) unauthorised access to or use of your account; (iv) any
//           interruption or cessation of transmission to or from the Platform; or
//           (v) any events beyond our reasonable control. Nothing in these Terms
//           excludes or limits liability that cannot be excluded under applicable
//           law.
//         </p>

//         <strong>3.16 Acknowledgement of Limitations</strong>
//         <p>
//           By using the Platform, you expressly acknowledge and accept these
//           limitations and disclaimers. You agree that any decision you make
//           based on consultations, reports or other services obtained through the
//           Platform is your sole responsibility.
//         </p>

//         <strong>3.17 Future Services</strong>
//         <p>
//           AstroBhagya may introduce additional forms of consultations (such as
//           video calls, webinars or group sessions), numerology, birth-chart
//           readings, astrology-related products or subscription packages in the
//           future. All such services will be subject to these Terms and any
//           additional conditions notified at the time of introduction.
//         </p>

//         <strong>3.18 Governing Policy Documents</strong>
//         <p>
//           This Scope of Services should be read in conjunction with our Privacy
//           Policy, Refund Policy and other legal notices published on the
//           Platform. Together they form part of your agreement with AstroBhagya.
//         </p>
//         <h5>4. Eligibility Criteria for Using AstroBhagya</h5>

//         <strong>Minimum Age Requirement</strong>
//         <p>
//           By using AstroBhagya, you confirm that you are at least 18 years of
//           age and legally competent to enter into a binding contract under the
//           Indian Contract Act, 1872.
//         </p>

//         <strong>Personal Use Only</strong>
//         <p>
//           The right to use AstroBhagya is personal and non-transferable. You may
//           not transfer or share your account credentials with any other person
//           or entity.
//         </p>

//         <strong>Single Account Policy</strong>
//         <p>
//           Each User may maintain only one active account linked to a valid
//           mobile number or login ID. Multiple accounts created with different
//           numbers/emails are strictly prohibited and may result in suspension or
//           termination.
//         </p>

//         <strong>Accurate &amp; Updated Registration Data</strong>
//         <p>
//           While registering, you agree to provide current, complete, and
//           accurate information and to keep it updated at all times. If the
//           information is found to be false, incomplete, or outdated, AstroBhagya
//           reserves the right to suspend or terminate your account.
//         </p>

//         <strong>Account Security</strong>
//         <p>
//           You are solely responsible for maintaining the confidentiality of your
//           password/OTP and login credentials. Any activity carried out through
//           your account will be deemed to have been performed by you. You must
//           log out at the end of each session and immediately inform AstroBhagya
//           of any unauthorized use or security breach.
//         </p>

//         <strong>Use by or on Behalf of Minors</strong>
//         <p>
//           AstroBhagya’s services are not intended for minors. However, you may
//           ask questions related to minors in your family within the scope of the
//           services, provided you yourself meet the eligibility criteria and take
//           full responsibility for such queries.
//         </p>

//         <strong>Restricted Jurisdictions &amp; Practices</strong>
//         <p>You are not eligible to use AstroBhagya’s services if:</p>
//         <ul>
//           <li>
//             You reside in a jurisdiction where use of such services is
//             prohibited by law, regulation, treaty or administrative act.
//           </li>
//           <li>
//             Your participation is barred due to religious practices or
//             restrictions.
//           </li>
//         </ul>

//         <strong>Financial Information &amp; Digital Transactions</strong>
//         <p>
//           By using AstroBhagya, you acknowledge that while we and our payment
//           partners employ reasonable security measures, digital transactions
//           inherently carry minor risks of theft, misuse, or fraud which are
//           beyond our reasonable control.
//         </p>

//         <strong>Third-Party Services</strong>
//         <p>
//           While availing services, you will be informed whether the service is
//           provided directly by AstroBhagya or by a third party. AstroBhagya
//           shall have no control over or responsibility for third-party content
//           or information dissemination once it leaves the Platform.
//         </p>

//         <strong>Consent to Communication</strong>
//         <p>
//           By registering and using AstroBhagya, you consent to receive
//           notifications, alerts, and communications via push notifications,
//           WhatsApp, RCS, SMS, email or other channels related to your account
//           and services.
//         </p>
//         <h5>5. Account Creation &amp; Security</h5>

//         <strong>5.1 Registration Requirements</strong>
//         <p>
//           To access certain features or Services, you may be required to create
//           an account on the Platform. When creating an account, you will be
//           asked to provide information such as your full name, contact details,
//           email address, date of birth, and, if applicable, payment information.
//           For astrologers, additional verification documents may be requested,
//           such as identity proof, qualifications, and bank account details for
//           payouts.
//         </p>
//         <p>You agree to:</p>
//         <ul>
//           <li>Provide accurate, current, and complete registration details.</li>
//           <li>
//             Promptly update your information to maintain its accuracy and
//             completeness.
//           </li>
//           <li>
//             Comply with any verification processes we may implement from time to
//             time.
//           </li>
//         </ul>
//         <p>
//           Failure to comply with these requirements may result in suspension or
//           termination of your account.
//         </p>

//         <strong>5.2 Login Credentials &amp; Confidentiality</strong>
//         <p>
//           Upon successful registration, you will create a username and password
//           (or other secure credentials). You are solely responsible for
//           maintaining the confidentiality of your login credentials and for all
//           activities that occur under your account. You agree to:
//         </p>
//         <ul>
//           <li>
//             Keep your password confidential and not share it with any third
//             party.
//           </li>
//           <li>
//             Immediately notify AstroBhagya of any unauthorized use of your
//             account or any other breach of security.
//           </li>
//           <li>
//             Ensure that you log out from your account at the end of each
//             session, especially when using shared devices.
//           </li>
//         </ul>
//         <p>
//           AstroBhagya shall not be liable for any loss or damage arising from
//           your failure to comply with these obligations.
//         </p>

//         <strong>5.3 Security of Accounts</strong>
//         <p>
//           We employ reasonable administrative, technical, and physical
//           safeguards to protect the security of our systems. However, no system
//           is completely secure. By using the Platform, you acknowledge that you
//           provide your information at your own risk and that AstroBhagya cannot
//           guarantee absolute protection against unauthorized access.
//         </p>
//         <p>You agree not to:</p>
//         <ul>
//           <li>
//             Circumvent or attempt to circumvent any security measures on the
//             Platform.
//           </li>
//           <li>
//             Use another User’s or Astrologer’s account without authorization.
//           </li>
//           <li>Create or use accounts through automated means or bots.</li>
//         </ul>
//         <p>
//           Any such activities may result in immediate suspension or termination
//           of your account and may also lead to civil or criminal liability under
//           Applicable Law.
//         </p>

//         <strong>5.4 Account Suspension &amp; Termination</strong>
//         <p>
//           AstroBhagya reserves the right to suspend, restrict, or permanently
//           terminate your account without notice if:
//         </p>
//         <ul>
//           <li>You violate or breach these Terms.</li>
//           <li>We suspect fraudulent, abusive, or illegal activity.</li>
//           <li>You provide false or misleading information.</li>
//           <li>Required by law enforcement or regulatory authorities.</li>
//         </ul>
//         <p>
//           Upon termination, your right to use the Platform ceases immediately.
//           Any outstanding obligations, including payment of fees or charges
//           incurred prior to termination, shall survive the termination of your
//           account. You may also request voluntary deletion of your account by
//           contacting our support team. Please note that certain transactional or
//           legal data may be retained for record-keeping or compliance purposes
//           even after account deletion.
//         </p>
//         <h5>6. User Responsibilities</h5>

//         <p>
//           By registering on or using the Platform, you agree to abide by the
//           following responsibilities:
//         </p>

//         <strong>6.1 Accurate Information</strong>
//         <p>
//           You agree to provide only true, accurate, current, and complete
//           information when creating your account and when submitting any
//           personal details such as birth data for astrology consultations. You
//           also agree to update your details promptly if there are any changes.
//           AstroBhagya shall not be responsible for any incorrect predictions,
//           reports, or consultations arising from inaccurate information provided
//           by you.
//         </p>

//         <strong>6.2 Respectful and Lawful Use</strong>
//         <p>
//           You agree not to use the Platform or interact with Astrologers in any
//           manner that is abusive, threatening, harassing, defamatory, obscene,
//           hateful, or otherwise objectionable. You further agree not to:
//         </p>
//         <ul>
//           <li>
//             Violate any applicable local, state, national, or international
//             laws.
//           </li>
//           <li>Engage in fraudulent activities or misrepresentation.</li>
//           <li>
//             Post, share, or transmit any content that infringes the intellectual
//             property rights or privacy of others.
//           </li>
//         </ul>
//         <p>
//           We reserve the right to suspend or terminate your account for any
//           conduct that we believe violates these responsibilities or is harmful
//           to other Users, Astrologers, or the integrity of the Platform.
//         </p>

//         <strong>6.3 No Misuse of Platform Features</strong>
//         <p>You agree not to:</p>
//         <ul>
//           <li>
//             Use automated scripts, bots, or other unauthorized tools to access,
//             scrape, or interfere with the Platform.
//           </li>
//           <li>
//             Attempt to circumvent or disable any security features of the
//             Platform.
//           </li>
//           <li>
//             Record, copy, or redistribute any consultations or content from the
//             Platform without prior written consent from AstroBhagya and/or the
//             Astrologer concerned.
//           </li>
//           <li>
//             Solicit or encourage Astrologers to conduct consultations outside
//             the Platform to bypass the payment system.
//           </li>
//         </ul>
//         <p>
//           Violation of these prohibitions may result in immediate suspension or
//           permanent termination of your account and may expose you to legal
//           action.
//         </p>
//         <h5>7. Astrologer / Provider Obligations</h5>

//         <p>
//           AstroBhagya also sets clear expectations for all Astrologers who
//           register to provide services through the Platform.
//         </p>

//         <strong>7.1 Registration and Verification</strong>

//         <p>
//           Astrologers must complete the registration process and provide all
//           requested documentation, including but not limited to identity proof,
//           qualifications, police verification, experience proof, address
//           verification, Aadhaar verification, contact details, and bank account
//           information for payouts. AstroBhagya reserves the right to verify or
//           re-verify this information periodically. Failure to provide accurate
//           or updated details may lead to suspension of the Astrologer’s account.
//         </p>

//         <strong>7.2 Payment Terms for Astrologers</strong>

//         <p>
//           Astrologers will be compensated according to the per-minute or
//           per-session rate displayed on the Platform or otherwise agreed upon in
//           writing. Currently, the standard rate is ₹10 per minute (exclusive of
//           taxes). Applicable taxes such as GST and TDS will be deducted in
//           accordance with prevailing laws before payment is credited to the
//           Astrologer’s registered bank account. Payments will typically be
//           processed on a weekly or monthly cycle as communicated by AstroBhagya.
//         </p>

//         <p>
//           Astrologers must ensure that their bank account and tax information
//           are accurate to avoid delays. AstroBhagya is not responsible for
//           delays caused by incorrect details provided by the Astrologer, banks,
//           or payment processors.
//         </p>

//         <strong>7.3 Ethical Standards for Consultations</strong>

//         <p>Astrologers agree to:</p>
//         <ul>
//           <li>
//             Provide honest, respectful, and ethical consultations to Users.
//           </li>
//           <li>
//             Avoid making exaggerated claims or promises of guaranteed results.
//           </li>
//           <li>
//             Refrain from offering medical, legal, or financial advice outside
//             the scope of astrology.
//           </li>
//           <li>
//             Maintain the confidentiality of all User information shared during
//             consultations.
//           </li>
//           <li>
//             Not solicit direct payments, gifts, or personal contact details from
//             Users outside the Platform.
//           </li>
//         </ul>

//         <p>
//           AstroBhagya reserves the right to suspend or permanently remove
//           Astrologers who breach these obligations, receive repeated complaints,
//           or engage in fraudulent or unethical conduct.
//         </p>
//         <h5>8. Pricing, Payments & Billing</h5>

//         <strong>8.1 Currency and Applicable Taxes</strong>
//         <p>
//           Astro Bhagya believes in building trust with our users which is why we
//           offer a free 5 minutes astrology chat and talk session to each of our
//           new users. After this free period of 5 mins, User will be charged
//           minimum rate of ₹10 (Indian Rupees) per minute for chat/calls. Users
//           will be informed of the applicable charges before initiating any paid
//           consultation charges.
//         </p>

//         <p>
//           All prices for services will be displayed in Indian Rupees (₹) on
//           Astro Bhagya portal. Applicable Tax( if any) will also be available on
//           portal. Users and Astrologers are responsible for any taxes imposed
//           under applicable laws.
//         </p>

//         <strong>8.2 Payment Methods</strong>

//         <p>
//           Payments for Services must be made through the payment methods
//           supported by the Platform, such as credit/debit cards, net banking,
//           UPI, mobile wallets, or any other online gateway enabled from time to
//           time. Cash payments or direct transfers to Astrologers are strictly
//           prohibited and may lead to suspension of both User and Astrologer
//           accounts.
//         </p>

//         <strong>8.3 Timing of Charges</strong>

//         <p>Depending on the type of Service, Users may be required to:</p>
//         <ul>
//           <li>
//             Prepay: Purchase credits or minutes in advance before starting a
//             consultation;
//           </li>
//           <li>
//             Charges are automatically deducted from the User’s chosen payment
//             method or wallet balance at the end of a session. By using the
//             Platform, you authorize AstroBhagya to charge your selected payment
//             method for all fees incurred.
//           </li>
//         </ul>

//         <strong>8.4 GST and TDS Deductions</strong>

//         <p>
//           For Astrologers, payments are made net of applicable taxes. For
//           example, GST at 18% and TDS at the prevailing rate will be deducted at
//           source before remitting payment to the Astrologer’s bank account.
//           AstroBhagya will provide invoices and/or payment statements as
//           required under Indian tax laws.
//         </p>

//         <p>
//           AstroBhagya is not responsible for any additional taxes, fees, or
//           charges levied by banks, credit card issuers, or payment processors.
//         </p>
//         <h5>9. Limitation of Liability / Disclaimers</h5>

//         <strong>9.1 No Guarantee of Predictions</strong>

//         <p>
//           Astrology is an interpretative science and art form. All
//           consultations, reports, and remedies offered through the Platform are
//           for informational and guidance purposes only. AstroBhagya does not
//           guarantee the accuracy, reliability, or effectiveness of any
//           prediction, suggestion, or remedy provided by an Astrologer.
//         </p>

//         <strong>9.2 Not Responsible for Consequences</strong>

//         <p>You acknowledge and agree that:</p>
//         <ul>
//           <li>
//             AstroBhagya and its Astrologers are not responsible for any
//             financial, medical, legal, emotional, or other consequences arising
//             from the use of Services.
//           </li>
//           <li>
//             You are solely responsible for any decisions or actions taken based
//             on the advice received from Astrologers.
//           </li>
//           <li>
//             The Platform is not a substitute for professional advice in medical,
//             legal, or financial matters.
//           </li>
//         </ul>

//         <strong>9.3 Platform Provided “As-Is”</strong>

//         <p>
//           The Platform and all Services are provided on an “as-is” and
//           “as-available” basis without any warranties of any kind, express or
//           implied. Without limiting the foregoing, AstroBhagya disclaims all
//           warranties of merchantability, fitness for a particular purpose,
//           non-infringement, and any warranties arising from course of dealing or
//           usage of trade.
//         </p>

//         <p>
//           AstroBhagya does not warrant that the Platform will be uninterrupted,
//           secure, or error-free, or that any defects will be corrected. You
//           acknowledge that you use the Platform at your own risk.
//         </p>

//         <strong>9.4 Limitation of Liability</strong>

//         <p>
//           To the fullest extent permitted by law, AstroBhagya, its affiliates,
//           employees, and Astrologers shall not be liable for any indirect,
//           incidental, special, consequential, or punitive damages, including
//           loss of profits, data, goodwill, or other intangible losses, resulting
//           from:
//         </p>
//         <ul>
//           <li>Your access to or use of the Platform;</li>
//           <li>Any advice or content obtained through the Platform;</li>
//           <li>
//             Unauthorized access to or use of your account or personal data;
//           </li>
//           <li>Any other matter relating to the Platform or Services.</li>
//         </ul>

//         <p>
//           If AstroBhagya is found liable for any claim, our total liability
//           shall not exceed the amount you paid for the Service giving rise to
//           the claim.
//         </p>

//         <h5>10. Intellectual Property Rights</h5>

//         <strong>10.1 Ownership of Content</strong>

//         <p>
//           All content, software, source code, user interfaces, designs,
//           graphics, logos, trade names, trademarks, service marks and other
//           intellectual property displayed on or embodied within the Platform are
//           and shall remain the exclusive property of the Company and/or its
//           licensors. No right, title or interest in any intellectual property is
//           transferred to you by virtue of your access to or use of the Platform.
//           All rights not expressly granted are reserved.
//         </p>

//         <strong>10.2 Licences Granted to Users</strong>

//         <p>
//           Subject to your compliance with these Terms, the Company grants you a
//           limited, non-exclusive, non-transferable, revocable licence to access
//           and use the Platform solely for its intended purposes. This licence
//           does not permit you to download, copy, reproduce, modify, adapt,
//           create derivative works from, publicly display, publicly perform,
//           distribute, transmit, broadcast, sell, licence or otherwise exploit
//           any portion of the Platform or its content except as expressly
//           authorised in writing.
//         </p>

//         <strong>10.3 Prohibition of Copying or Redistribution</strong>

//         <p>
//           You must not copy, redistribute, transmit, display, perform,
//           reproduce, publish, license, create derivative works from, transfer,
//           or sell any information, software, products or services obtained from
//           the Platform without prior written consent from the Company.
//           Unauthorised use may constitute infringement of copyright, trademark
//           and other laws and may give rise to civil and criminal liability.
//         </p>

//         <strong>10.4 User-Generated Content</strong>

//         <p>
//           Where you submit, upload or post content to the Platform, you grant
//           the Company a worldwide, royalty-free, perpetual, irrevocable,
//           non-exclusive licence to use, reproduce, modify, adapt, publish,
//           translate, create derivative works from, distribute, perform and
//           display such content for the purposes of operating and promoting the
//           Platform. You warrant that you own or have the necessary rights to
//           grant such licence and that your content does not infringe the rights
//           of any third party.
//         </p>

//         <strong>10.5 Infringement Notices</strong>

//         <p>
//           If you believe any content on the Platform infringes your intellectual
//           property rights, please notify us in writing with sufficient details
//           to enable us to investigate and, where appropriate, remove or disable
//           access to the infringing content.
//         </p>

//         <h5>11. Privacy and Data Protection</h5>

//         <strong>11.1 General</strong>

//         <p>
//           The Company takes the privacy of its users seriously and complies with
//           applicable data protection laws.
//         </p>

//         <strong>11.2 Data Collected</strong>

//         <p>
//           We may collect and process the following categories of personal data:
//         </p>
//         <ul>
//           <li>
//             Information you provide when registering, creating an account or
//             using our services (such as your name, contact details, date of
//             birth, documents (if applicable) payment information and
//             preferences);
//           </li>
//           <li>
//             Technical data automatically collected from your device (including
//             IP address, browser type, operating system, time zone and cookies);
//           </li>
//           <li>
//             Information relating to your transactions and interactions on the
//             Platform;
//           </li>
//           <li>
//             Communications you send to us, including customer support requests
//             or feedback.
//           </li>
//         </ul>
//         <strong>11.3 How We Use Your Data</strong>
//         <p>We process personal data to:</p>
//         <ul>
//           <li>Provide, maintain and improve the Platform and our services;</li>
//           <li>Process payments and fulfil contractual obligations;</li>
//           <li>Respond to your enquiries, requests and complaints;</li>
//           <li>Send administrative, transactional or service messages;</li>
//           <li>Comply with legal obligations and enforce our rights.</li>
//         </ul>

//         <strong>11.4 Data Storage and Security</strong>
//         <p>
//           We implement appropriate technical and organisational measures to
//           protect personal data against unauthorised or unlawful processing,
//           accidental loss, destruction or damage. Personal data is stored on
//           secure servers in jurisdictions that maintain adequate data protection
//           standards. Where data is transferred across jurisdictions, we ensure
//           that suitable safeguards are in place.
//         </p>

//         <strong>11.5 Retention</strong>
//         <p>
//           We retain personal data only for as long as necessary to fulfil the
//           purposes for which it was collected, or as required by law. Once data
//           is no longer needed, it is securely deleted or anonymised.
//         </p>

//         <strong>11.6 Third-Party Processors</strong>
//         <p>
//           We may engage trusted third-party service providers to perform certain
//           functions on our behalf, such as payment processing, data analytics,
//           hosting and customer support. Such providers will only have access to
//           the personal data necessary to perform their functions and are bound
//           by contractual obligations to keep it secure and use it only in
//           accordance with our instructions.
//         </p>

//         <strong>11.7 Your Rights</strong>
//         <p>
//           You have rights under data protection laws, including the right to
//           access, rectify or erase your personal data, the right to restrict or
//           object to processing, the right to data portability, and the right to
//           withdraw consent at any time where processing is based on consent. To
//           exercise your rights, please contact us at the details provided in our
//           Privacy Policy.
//         </p>

//         <strong>11.8 Reference to Privacy Policy</strong>
//         <p>
//           Further details regarding how we collect, use and protect your
//           personal data can be found in our separate Privacy Policy, which forms
//           part of these Terms. By using the Platform, you acknowledge that you
//           have read and understood the Privacy Policy.
//         </p>

//         <h5>12. Third-Party Links and Services</h5>

//         <strong>12.1 Third-Party Websites</strong>
//         <p>
//           The Platform may contain links to third-party websites, services or
//           resources that are not owned or controlled by the Company. Such links
//           are provided for your convenience only. We do not endorse or assume
//           any responsibility for the content, privacy policies or practices of
//           any third-party websites or services.
//         </p>

//         <strong>12.2 No Liability</strong>
//         <p>
//           You acknowledge and agree that the Company shall not be liable,
//           directly or indirectly, for any damage or loss caused or alleged to be
//           caused by or in connection with the use of or reliance on any content,
//           goods or services available on or through such third-party websites or
//           services.
//         </p>

//         <strong>12.3 Third-Party Integrations</strong>
//         <p>
//           Where the Platform integrates with third-party software, payment
//           gateways or other services, your use of those services may be subject
//           to the third party’s terms and conditions and privacy policies. It is
//           your responsibility to review and comply with such terms.
//         </p>

//         <h5>13. Termination of Access</h5>

//         <strong>13.1 Suspension or Termination by the Company</strong>
//         <p>
//           We reserve the right to suspend or terminate your account and/or
//           access to the Platform at any time, with or without notice, if we
//           reasonably believe that you have breached these Terms, engaged in
//           fraudulent or illegal activities, caused harm to other users or to the
//           Company, or if required to do so by law or regulatory authorities.
//         </p>
//         <strong>13.2 Effect of Termination</strong>
//         <p>
//           Upon termination, your right to access and use the Platform shall
//           cease immediately. We may, at our discretion, delete or disable access
//           to any of your data or content stored on the Platform. Certain
//           provisions of these Terms, including intellectual property rights,
//           disclaimers, indemnities and limitations of liability, shall survive
//           termination.
//         </p>

//         <strong>13.3 Remaining Credits and Payments</strong>
//         <p>
//           Where your account holds unused credits, balances or pre-paid fees at
//           the time of termination, the Company will handle such amounts in
//           accordance with applicable law and its Refund Policy. In cases of
//           termination due to your breach of these Terms or fraudulent activity,
//           you may forfeit any such balances. In all other cases, the Company
//           will make reasonable efforts to refund unused amounts after deducting
//           any outstanding charges or liabilities.
//         </p>

//         <strong>13.4 Voluntary Closure</strong>
//         <p>
//           You may close your account at any time by contacting us. Closing your
//           account does not relieve you of any obligations incurred prior to
//           closure, including payment of any fees due.
//         </p>

//         <h5>14. Indemnification</h5>

//         <strong>14.1 User’s Obligations</strong>
//         <p>
//           You agree to defend, indemnify and hold harmless the Company, its
//           affiliates, directors, officers, employees, agents, contractors and
//           licensors from and against all claims, liabilities, damages, losses,
//           costs, expenses or fees (including reasonable legal fees) arising out
//           of or relating to:
//         </p>
//         <ul>
//           <li>Your use or misuse of the Platform;</li>
//           <li>Your violation of these Terms;</li>
//           <li>
//             Your infringement of any intellectual property or other right of any
//             person or entity;
//           </li>
//           <li>
//             Any content you submit, post or transmit through the Platform.
//           </li>
//         </ul>

//         <strong>14.2 Company’s Rights</strong>
//         <p>
//           We reserve the right, at our own expense, to assume the exclusive
//           defence and control of any matter subject to indemnification by you,
//           in which case you agree to cooperate with us in asserting any
//           available defences.
//         </p>

//         <strong>14.3 Limitation</strong>
//         <p>
//           This indemnity does not limit or exclude any liability that cannot be
//           limited or excluded under applicable law.
//         </p>

//         <h5>15. Governing Law and Jurisdiction</h5>

//         <strong>15.1 Applicable Law</strong>
//         <p>
//           These Terms and any disputes or claims arising out of or in connection
//           with them (including non-contractual disputes or claims) shall be
//           governed by and construed in accordance with the laws of England and
//           Wales, without regard to its conflict of law provisions.
//         </p>

//         <strong>15.2 Jurisdiction</strong>
//         <p>
//           The courts of England and Wales shall have exclusive jurisdiction to
//           settle any dispute or claim arising out of or in connection with these
//           Terms or their subject matter. However, if you are a consumer resident
//           in another country, you may also bring proceedings in your home courts
//           under mandatory consumer protection laws.
//         </p>

//         <strong>15.3 Alternative Dispute Resolution</strong>
//         <p>
//           We may, at our discretion, offer to resolve disputes through mediation
//           or another form of alternative dispute resolution before resorting to
//           litigation. Participation in such processes does not affect either
//           party’s right to commence court proceedings at any time.
//         </p>

//         <strong>15.4 Severability</strong>
//         <p>
//           If any provision of these Terms is found by a court or competent
//           authority to be invalid or unenforceable, that provision shall be
//           deemed modified to the minimum extent necessary to make it valid and
//           enforceable, and the remaining provisions shall remain in full force
//           and effect.
//         </p>

//         <h5>16. Changes to Terms</h5>

//         <strong>16.1 Right to Amend or Update</strong>
//         <p>
//           The Company reserves the right, at its sole discretion, to amend,
//           update or replace any part of these Terms at any time in order to
//           reflect changes in law, regulatory requirements, business practices,
//           or the scope of services offered on the Platform. Such changes shall
//           take effect on the date specified in the updated Terms or, if no date
//           is specified, immediately upon publication.
//         </p>

//         <strong>16.2 Notification of Changes</strong>
//         <p>
//           We will endeavour to give you reasonable notice of any material
//           changes to these Terms. Notification may be provided by one or more of
//           the following means:
//         </p>
//         <ul>
//           <li>Posting the updated Terms on the Platform;</li>
//           <li>
//             Sending an e-mail to the address associated with your account;
//           </li>
//           <li>
//             Displaying a prominent notice or pop-up when you next access the
//             Platform;
//           </li>
//           <li>
//             Any other method reasonably designed to bring the changes to your
//             attention.
//           </li>
//         </ul>

//         <strong>16.3 User’s Responsibility</strong>
//         <p>
//           It is your responsibility to review the Terms regularly to ensure you
//           are aware of the current version. By continuing to access or use the
//           Platform after changes have taken effect, you agree to be bound by the
//           revised Terms. If you do not agree with the changes, you should
//           discontinue use of the Platform and close your account in accordance
//           with Clause 14.4.
//         </p>

//         <strong>16.4 Historical Versions</strong>
//         <p>
//           The Company may, but is not obliged to, retain and make available
//           archived versions of previous Terms for reference. These do not
//           constitute a waiver of any rights or obligations under the current
//           Terms.
//         </p>

//         <h5>17. Contact Information</h5>

//         <strong>17.1 General Enquiries</strong>
//         <p>
//           If you have any questions, concerns or complaints regarding the
//           Platform or these Terms, you may contact us using the details provided
//           below. We will make reasonable efforts to respond to enquiries
//           promptly and in accordance with applicable consumer protection
//           standards.
//         </p>

//         <strong>17.2 Support E-mail</strong>
//         <p>
//           For all customer service and support enquiries, please write to{" "}
//           <a href="mailto:business@astrobhagya.co.in">
//             business@astrobhagya.co.in
//           </a>
//           . E-mails sent to this address are automatically logged and routed to
//           our support team.
//         </p>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default TermsAndConditions;

import React from "react";
import "../privacypolicy/Privacypolicy.css";
import { Link } from "react-router-dom";
import Header from "../header/header";
import Footer from "../footer/footer";

const TermsAndConditions = () => {
  return (
    <div>
      <Header />
      <div className="terms-page">
        <h4>AstroBhagya – Terms & Conditions</h4>
        <p>
          <b>AstroBhagya App</b>, developed and managed by{" "}
          <b>Heavenly Expectation Private Limited</b>, offers trusted astrology
          services and personalized guidance in a modern digital format.
        </p>

        {/* ───────────────────────── 1 ───────────────────────── */}
        <h5>1. Introduction / Agreement</h5>
        <p>
          Welcome to AstroBhagya. ("AstroBhagya," "we," "us" or "our") is an
          online platform through which users can connect with qualified
          astrologers to obtain astrology consultations primarily via real-time
          chat and telephone calls. The Platform facilitates secure booking,
          payment processing and communication between users and astrologers,
          and may from time to time offer related content, reports or additional
          services.
        </p>
        <p>
          These Terms &amp; Conditions ("Terms") govern your access to and use
          of the Platform, including our website, mobile application, and any
          content, functionality, products, or services offered through it. By
          accessing, browsing, downloading, or using the Platform in any manner,
          you acknowledge that you have read, understood, and agreed to be bound
          by these Terms and our Privacy Policy (incorporated herein by
          reference). If you do not agree to all of these Terms, you must
          immediately discontinue use of the Platform.
        </p>
        <p>
          We reserve the right to update, revise, or replace these Terms at any
          time, without prior notice, at our sole discretion. The date of the
          latest revision is indicated at the top of this page. It is your
          responsibility to review these Terms periodically for changes. Your
          continued use of the Platform after posting of any revised Terms
          constitutes your acceptance of the updated Terms.
        </p>
        <p>
          The Platform is intended for users located in India, but it may be
          accessible to users outside India as well. All services, charges, and
          policies are subject to the laws and regulations of India.
        </p>

        {/* ───────────────────────── 2 ───────────────────────── */}
        <h5>2. Definitions</h5>
        <p>
          For purposes of these Terms, the following words and expressions shall
          have the meanings set out below. These definitions are intended to
          clarify, not to limit, the scope of these Terms:
        </p>
        <ul>
          <li>
            <strong>
              "AstroBhagya" / "we" / "us" / "our" / "the Platform":
            </strong>{" "}
            Refers to the legal entity operating the online platform, including
            its employees, directors, officers, agents, successors, and assigns.
          </li>
          <li>
            <strong>"User" / "you" / "your":</strong> Any individual or entity
            who accesses, registers on, browses, or uses the Platform or any of
            its services, whether or not they create an account or make a
            payment.
          </li>
          <li>
            <strong>"Astrologer" / "Service Provider":</strong> Any verified
            practitioner, consultant, or expert in astrology or related fields
            who offers consultation, advice, or other services through the
            Platform to Users. This includes individuals engaged by AstroBhagya
            on a contractual or freelance basis.
          </li>
          <li>
            <strong>"Services":</strong> All services, features, and functions
            provided or facilitated by AstroBhagya through the Platform. This
            includes but is not limited to: live chat consultations, audio/video
            calls, personalized horoscope reports, birth chart analyses,
            remedial suggestions, and any other astrology-related content or
            products.
          </li>
          <li>
            <strong>"Account":</strong> The personal profile created by a User
            or Astrologer upon registration on the Platform, which contains
            information such as name, contact details, birth details, payment
            information, and consultation history.
          </li>
          <li>
            <strong>"Content":</strong> Any text, images, videos, audio, data,
            graphics, or other materials uploaded, transmitted, or made
            available through the Platform, whether by AstroBhagya, Users, or
            Astrologers.
          </li>
          <li>
            <strong>"Privacy Policy":</strong> The separate policy statement
            published by AstroBhagya that explains how we collect, use, and
            protect Users' personal data.
          </li>
          <li>
            <strong>"Applicable Law":</strong> All statutes, regulations, rules,
            ordinances, notifications, and other legal instruments in force in
            India and, where relevant, in other jurisdictions.
          </li>
        </ul>

        {/* ───────────────────────── 3 ───────────────────────── */}
        <h5>3. Scope of Services</h5>

        <strong>3.1 Nature of the Platform</strong>
        <p>
          AstroBhagya is an intermediary platform designed to facilitate online
          astrology consultations and related services between users ("Users")
          and independent practitioners of astrology and associated disciplines
          ("Astrologers"). We provide a secure technological interface and
          administrative support so that Users can easily discover, book and pay
          for consultations with Astrologers. The Platform is a marketplace and
          communications tool; we are not the employer of Astrologers and do not
          directly provide astrology services ourselves.
        </p>

        <strong>3.2 Core Services Offered</strong>
        <p>
          Without limitation, the main services currently provided on the
          Platform include:
        </p>
        <ul>
          <li>
            <strong>Live Consultations:</strong> Real-time chat sessions and
            audio or telephone calls with Astrologers for personal astrological
            guidance.
          </li>
          <li>
            <strong>Written Reports:</strong> Personalised horoscope analyses,
            compatibility assessments, and remedial suggestions delivered in
            written or digital form.
          </li>
          <li>
            <strong>Knowledge Resources:</strong> Access to articles, blogs,
            videos and other educational materials on astrology, vastu and
            related topics curated or facilitated by AstroBhagya.
          </li>
          <li>
            <strong>Astrologer Dashboard:</strong> Digital tools enabling
            Astrologers to manage their profiles, schedules, appointments,
            communications and payments.
          </li>
        </ul>
        <p>
          We may from time to time introduce new features, services or products,
          or modify or discontinue existing ones, at our discretion.
        </p>

        <strong>3.3 Verification of Astrologers</strong>
        <p>
          We strive to ensure that only verified and competent Astrologers are
          listed on the Platform. Verification may include identity checks,
          background screening, Aadhaar verification, police verification,
          sample consultations and collection of references. However, the
          listing of an Astrologer on the Platform does not constitute a
          warranty or endorsement of that individual's qualifications,
          experience, competence, integrity or accuracy of advice. All services
          provided by Astrologers are offered in their personal capacity as
          independent service providers.
        </p>

        <strong>3.4 Independence of Advice</strong>
        <p>
          AstroBhagya does not control, direct or influence the substance of any
          consultation, report or other service provided by an Astrologer. All
          such advice represents the independent opinion of the Astrologer and
          does not constitute a recommendation, endorsement or guarantee by
          AstroBhagya. Any reliance on such advice is solely at your own
          discretion and risk.
        </p>

        <strong>3.5 Limitations of Services</strong>
        <p>You acknowledge and agree to the following limitations:</p>
        <ul>
          <li>
            <strong>Informational Nature:</strong> Services provided through the
            Platform are intended solely for informational, entertainment and
            guidance purposes. They should not be considered a substitute for
            professional advice in medical, legal, financial, psychological or
            other specialised fields.
          </li>
          <li>
            <strong>No Guarantee of Accuracy or Effectiveness:</strong> The
            accuracy, reliability or effectiveness of any prediction,
            suggestion, remedy or product cannot be guaranteed. Outcomes may
            vary depending on individual circumstances and no particular result
            is promised.
          </li>
          <li>
            <strong>Remedies and Products:</strong> Any remedial products,
            rituals or recommendations offered by Astrologers (such as
            gemstones, mantras, poojas or astrological remedies) are to be
            undertaken at your own discretion and risk. AstroBhagya is not
            responsible for the effectiveness, side-effects, authenticity or
            safety of such remedies or products.
          </li>
          <li>
            <strong>Third-Party Services:</strong> Where an Astrologer refers
            you to or sells you products or services from a third party, such
            dealings are solely between you and that third party. AstroBhagya is
            not a party to, and does not accept liability for, such
            transactions.
          </li>
        </ul>

        <strong>3.6 Eligibility and Account Requirements</strong>
        <p>
          To access services on the Platform, Users and Astrologers must create
          an account and provide accurate, current and complete information. You
          are responsible for maintaining the confidentiality of your login
          credentials and for all activities that occur under your account. The
          Platform may impose minimum age or other eligibility criteria as
          required by law.
        </p>

        <strong>3.7 Payments and Pricing</strong>
        <p>
          AstroBhagya facilitates payment processing between Users and
          Astrologers. Charges for consultations, reports or other services will
          be displayed on the Platform. The final per-minute consultation rate
          shall be clearly displayed on the Astrologer's profile before
          initiating any chat or call. Payments are processed through secure
          payment gateways. AstroBhagya may deduct its commission or service
          fees before remitting balances to Astrologers. Taxes such as GST will
          be applied as required by applicable law. Refunds, if any, are
          governed by our Refund Policy.
        </p>

        <strong>3.8 Quality and Feedback</strong>
        <p>
          We may allow Users to rate or review Astrologers and their services to
          promote transparency. Ratings and reviews reflect the opinion of
          individual Users and do not constitute endorsements by AstroBhagya. We
          reserve the right to moderate, remove or edit reviews that violate our
          policies.
        </p>

        <strong>3.9 User Conduct on the Platform</strong>
        <p>
          Users must not misuse the Platform. Prohibited conduct includes but is
          not limited to: abusive or offensive language towards Astrologers or
          staff, attempts to solicit services outside the Platform, sharing
          false information, or nudity images, infringing intellectual property,
          uploading harmful content or engaging in fraudulent or illegal
          activities. We reserve the right to suspend or terminate accounts for
          violations.
        </p>

        <strong>3.10 Intellectual Property in Platform Content</strong>
        <p>
          All content created or provided by AstroBhagya, including the website,
          mobile application, user interfaces, branding, design, software,
          articles and educational resources, is owned by or licensed to
          AstroBhagya and protected under applicable intellectual property laws.
          Users are granted a limited, non-exclusive, non-transferable licence
          to access and use such content solely for personal, non-commercial
          purposes.
        </p>

        <strong>3.11 Service Availability and Technical Issues</strong>
        <p>
          We endeavour to keep the Platform available and functioning smoothly.
          However, we do not guarantee uninterrupted access and may suspend or
          restrict access for maintenance, upgrades, security reasons or
          circumstances beyond our control. We will use reasonable efforts to
          notify Users of planned downtime where practicable.
        </p>

        <strong>3.12 Modifications to Services</strong>
        <p>
          AstroBhagya may at any time, without liability, add, remove or alter
          any aspect of the Platform or its services, including features, pricing
          and availability, to reflect changes in law, technology, business
          needs or user demand. Continued use of the Platform following such
          changes constitutes acceptance of them. Consultation rates, including
          chat and call charges, are subject to change at any time without prior
          notice.
        </p>

        <strong>3.13 Disclaimer of Responsibility for Content</strong>
        <p>
          Content provided on or through the Platform by Astrologers or other
          Users is their own responsibility. While we may implement moderation
          or quality-control measures, we are not obliged to monitor all content
          and disclaim any liability for errors, omissions or unlawful material
          posted by third parties.
        </p>

        <strong>3.14 Third-Party Links and Integrations</strong>
        <p>
          The Platform may contain links to, or integrate with, third-party
          websites, applications or services. Such links or integrations are
          provided for convenience only. We do not endorse or assume
          responsibility for the content, privacy practices or availability of
          third-party services. Your use of them is at your own risk and subject
          to the relevant third party's terms and conditions.
        </p>

        <strong>3.15 Limitation of Liability</strong>
        <p>
          To the fullest extent permitted by law, AstroBhagya shall not be
          liable for any loss, damage or injury arising out of or in connection
          with: (i) reliance on advice or predictions provided by Astrologers;
          (ii) the purchase or use of any remedial product or recommendation;
          (iii) unauthorised access to or use of your account; (iv) any
          interruption or cessation of transmission to or from the Platform; or
          (v) any events beyond our reasonable control. Nothing in these Terms
          excludes or limits liability that cannot be excluded under applicable
          law.
        </p>

        <strong>3.16 Acknowledgement of Limitations</strong>
        <p>
          By using the Platform, you expressly acknowledge and accept these
          limitations and disclaimers. You agree that any decision you make
          based on consultations, reports or other services obtained through the
          Platform is your sole responsibility.
        </p>

        <strong>3.17 Future Services</strong>
        <p>
          AstroBhagya may introduce additional forms of consultations (such as
          video calls, webinars or group sessions), numerology, birth-chart
          readings, astrology-related products or subscription packages in the
          future. All such services will be subject to these Terms and any
          additional conditions notified at the time of introduction.
        </p>

        <strong>3.18 Governing Policy Documents</strong>
        <p>
          This Scope of Services should be read in conjunction with our Privacy
          Policy, Refund Policy and other legal notices published on the
          Platform. Together they form part of your agreement with AstroBhagya.
        </p>

        {/* ───────────────────────── 4 ───────────────────────── */}
        <h5>4. Eligibility Criteria for Using AstroBhagya</h5>

        <strong>Minimum Age Requirement</strong>
        <p>
          By using AstroBhagya, you confirm that you are at least 18 years of
          age and legally competent to enter into a binding contract under the
          Indian Contract Act, 1872.
        </p>

        <strong>Personal Use Only</strong>
        <p>
          The right to use AstroBhagya is personal and non-transferable. You may
          not transfer or share your account credentials with any other person
          or entity.
        </p>

        <strong>Single Account Policy</strong>
        <p>
          Each User may maintain only one active account linked to a valid
          mobile number or login ID. Multiple accounts created with different
          numbers/emails are strictly prohibited and may result in suspension or
          termination.
        </p>

        <strong>Accurate &amp; Updated Registration Data</strong>
        <p>
          While registering, you agree to provide current, complete, and
          accurate information and to keep it updated at all times. If the
          information is found to be false, incomplete, or outdated, AstroBhagya
          reserves the right to suspend or terminate your account.
        </p>

        <strong>Account Security</strong>
        <p>
          You are solely responsible for maintaining the confidentiality of your
          password/OTP and login credentials. Any activity carried out through
          your account will be deemed to have been performed by you. You must
          log out at the end of each session and immediately inform AstroBhagya
          of any unauthorized use or security breach.
        </p>

        <strong>Use by or on Behalf of Minors</strong>
        <p>
          AstroBhagya's services are not intended for minors. However, you may
          ask questions related to minors in your family within the scope of the
          services, provided you yourself meet the eligibility criteria and take
          full responsibility for such queries.
        </p>

        <strong>Restricted Jurisdictions &amp; Practices</strong>
        <p>You are not eligible to use AstroBhagya's services if:</p>
        <ul>
          <li>
            You reside in a jurisdiction where use of such services is
            prohibited by law, regulation, treaty or administrative act.
          </li>
          <li>
            Your participation is barred due to religious practices or
            restrictions.
          </li>
        </ul>

        <strong>Financial Information &amp; Digital Transactions</strong>
        <p>
          By using AstroBhagya, you acknowledge that while we and our payment
          partners employ reasonable security measures, digital transactions
          inherently carry minor risks of theft, misuse, or fraud which are
          beyond our reasonable control.
        </p>

        <strong>Third-Party Services</strong>
        <p>
          While availing services, you will be informed whether the service is
          provided directly by AstroBhagya or by a third party. AstroBhagya
          shall have no control over or responsibility for third-party content
          or information dissemination once it leaves the Platform.
        </p>

        <strong>Consent to Communication</strong>
        <p>
          By registering and using AstroBhagya, you consent to receive
          notifications, alerts, and communications via push notifications,
          WhatsApp, RCS, SMS, email or other channels related to your account
          and services.
        </p>

        {/* ───────────────────────── 5 ───────────────────────── */}
        <h5>5. Account Creation &amp; Security</h5>

        <strong>5.1 Registration Requirements</strong>
        <p>
          To access certain features or Services, you may be required to create
          an account on the Platform. When creating an account, you will be
          asked to provide information such as your full name, contact details,
          email address, date of birth, and, if applicable, payment information.
          For astrologers, additional verification documents may be requested,
          such as identity proof, qualifications, and bank account details for
          payouts.
        </p>
        <p>You agree to:</p>
        <ul>
          <li>Provide accurate, current, and complete registration details.</li>
          <li>
            Promptly update your information to maintain its accuracy and
            completeness.
          </li>
          <li>
            Comply with any verification processes we may implement from time to
            time.
          </li>
        </ul>
        <p>
          Failure to comply with these requirements may result in suspension or
          termination of your account.
        </p>

        <strong>5.2 Login Credentials &amp; Confidentiality</strong>
        <p>
          Upon successful registration, you will create a username and password
          (or other secure credentials). You are solely responsible for
          maintaining the confidentiality of your login credentials and for all
          activities that occur under your account. You agree to:
        </p>
        <ul>
          <li>
            Keep your password confidential and not share it with any third
            party.
          </li>
          <li>
            Immediately notify AstroBhagya of any unauthorized use of your
            account or any other breach of security.
          </li>
          <li>
            Ensure that you log out from your account at the end of each
            session, especially when using shared devices.
          </li>
        </ul>
        <p>
          AstroBhagya shall not be liable for any loss or damage arising from
          your failure to comply with these obligations.
        </p>

        <strong>5.3 Security of Accounts</strong>
        <p>
          We employ reasonable administrative, technical, and physical
          safeguards to protect the security of our systems. However, no system
          is completely secure. By using the Platform, you acknowledge that you
          provide your information at your own risk and that AstroBhagya cannot
          guarantee absolute protection against unauthorized access.
        </p>
        <p>You agree not to:</p>
        <ul>
          <li>
            Circumvent or attempt to circumvent any security measures on the
            Platform.
          </li>
          <li>
            Use another User's or Astrologer's account without authorization.
          </li>
          <li>Create or use accounts through automated means or bots.</li>
        </ul>
        <p>
          Any such activities may result in immediate suspension or termination
          of your account and may also lead to civil or criminal liability under
          Applicable Law.
        </p>

        <strong>5.4 Account Suspension &amp; Termination</strong>
        <p>
          AstroBhagya reserves the right to suspend, restrict, or permanently
          terminate your account without notice if:
        </p>
        <ul>
          <li>You violate or breach these Terms.</li>
          <li>We suspect fraudulent, abusive, or illegal activity.</li>
          <li>You provide false or misleading information.</li>
          <li>Required by law enforcement or regulatory authorities.</li>
        </ul>
        <p>
          Upon termination, your right to use the Platform ceases immediately.
          Any outstanding obligations, including payment of fees or charges
          incurred prior to termination, shall survive the termination of your
          account. You may also request voluntary deletion of your account by
          contacting our support team. Please note that certain transactional or
          legal data may be retained for record-keeping or compliance purposes
          even after account deletion.
        </p>

        {/* ───────────────────────── 6 ───────────────────────── */}
        <h5>6. User Responsibilities</h5>
        <p>
          By registering on or using the Platform, you agree to abide by the
          following responsibilities:
        </p>

        <strong>6.1 Accurate Information</strong>
        <p>
          You agree to provide only true, accurate, current, and complete
          information when creating your account and when submitting any
          personal details such as birth data for astrology consultations. You
          also agree to update your details promptly if there are any changes.
          AstroBhagya shall not be responsible for any incorrect predictions,
          reports, or consultations arising from inaccurate information provided
          by you.
        </p>

        <strong>6.2 Respectful and Lawful Use</strong>
        <p>
          You agree not to use the Platform or interact with Astrologers in any
          manner that is abusive, threatening, harassing, defamatory, obscene,
          hateful, or otherwise objectionable. You further agree not to:
        </p>
        <ul>
          <li>
            Violate any applicable local, state, national, or international
            laws.
          </li>
          <li>Engage in fraudulent activities or misrepresentation.</li>
          <li>
            Post, share, or transmit any content that infringes the intellectual
            property rights or privacy of others.
          </li>
        </ul>
        <p>
          We reserve the right to suspend or terminate your account for any
          conduct that we believe violates these responsibilities or is harmful
          to other Users, Astrologers, or the integrity of the Platform.
        </p>

        <strong>6.3 No Misuse of Platform Features</strong>
        <p>You agree not to:</p>
        <ul>
          <li>
            Use automated scripts, bots, or other unauthorized tools to access,
            scrape, or interfere with the Platform.
          </li>
          <li>
            Attempt to circumvent or disable any security features of the
            Platform.
          </li>
          <li>
            Record, copy, or redistribute any consultations or content from the
            Platform without prior written consent from AstroBhagya and/or the
            Astrologer concerned.
          </li>
          <li>
            Solicit or encourage Astrologers to conduct consultations outside
            the Platform to bypass the payment system.
          </li>
        </ul>
        <p>
          Violation of these prohibitions may result in immediate suspension or
          permanent termination of your account and may expose you to legal
          action.
        </p>

        {/* ───────────────────────── 7 ───────────────────────── */}
        <h5>7. Astrologer / Provider Obligations</h5>
        <p>
          AstroBhagya also sets clear expectations for all Astrologers who
          register to provide services through the Platform.
        </p>

        <strong>7.1 Registration and Verification</strong>
        <p>
          Astrologers must complete the registration process and provide all
          requested documentation. AstroBhagya reserves the right to verify or
          re-verify this information periodically. Failure to provide accurate
          or updated details may lead to suspension of the Astrologer's account.
        </p>
        <p>
          <strong>Mandatory Documents</strong>
        </p>
        <ul>
          <li>Aadhaar Card</li>
          <li>PAN Card</li>
          <li>Bank Passbook or Blank Cheque</li>
        </ul>
        <p>
          <strong>Optional Documents</strong>
        </p>
        <ul>
          <li>Astrology-related certificates</li>
          <li>Educational certificates</li>
          <li>Experience or skill proof</li>
        </ul>
        <p>
          Submission of optional documents is not mandatory for onboarding, and
          astrologers may provide services without them.
        </p>

        <strong>7.2 Payment Terms for Astrologers</strong>
        <p>
          Astrologers will be compensated according to the per-minute or
          per-session rate displayed on the Platform or otherwise agreed upon in
          writing. Currently, the standard rate is ₹10 per minute (exclusive of
          taxes).
        </p>
        <ul>
          <li>
            Astrologers are entitled to receive 41% of the total consultation
            amount earned through the App.
          </li>
          <li>
            Applicable GST shall be borne and paid by the Company, in
            accordance with prevailing tax laws.
          </li>
          <li>
            The remaining portion of the consultation amount shall be retained
            by the Company as its service fee.
          </li>
          <li>
            Astrologer payouts shall be processed once every month, and the
            payable amount will be credited to the astrologer's registered bank
            account on or the 7th day of each month.
          </li>
          <li>
            Payout cycles, minimum payout thresholds, and settlement details
            may be updated from time to time and will be communicated to
            astrologers through the App or other official communication
            channels.
          </li>
        </ul>
        <p>
          Astrologers must ensure that their bank account and tax information
          are accurate to avoid delays. AstroBhagya is not responsible for
          delays caused by incorrect details provided by the Astrologer, banks,
          or payment processors.
        </p>

        <strong>7.3 Ethical Standards for Consultations</strong>
        <p>Astrologers agree to:</p>
        <ul>
          <li>
            Provide honest, respectful, and ethical consultations to Users.
          </li>
          <li>
            Avoid making exaggerated claims or promises of guaranteed results.
          </li>
          <li>
            Refrain from offering medical, legal, or financial advice outside
            the scope of astrology.
          </li>
          <li>
            Maintain the confidentiality of all User information shared during
            consultations.
          </li>
          <li>
            Not solicit direct payments, gifts, or personal contact details from
            Users outside the Platform.
          </li>
        </ul>
        <p>
          AstroBhagya reserves the right to suspend or permanently remove
          Astrologers who breach these obligations, receive repeated complaints,
          or engage in fraudulent or unethical conduct.
        </p>

        {/* ───────────────────────── 8 ───────────────────────── */}
        <h5>8. Pricing, Payments &amp; Billing</h5>

        <strong>8.1 Currency &amp; Applicable Charges</strong>
        <p>
          All service charges on the AstroBhagya platform are displayed in
          Indian Rupees (₹). Any applicable taxes under prevailing laws shall be
          charged additionally, wherever applicable.
        </p>
        <p>
          Astrologers are entitled to set their own consultation rates at their
          discretion. The platform may prescribe a minimum base rate; however,
          actual consultation charges may vary depending on the astrologer
          selected. Users will be informed of applicable per-minute rates before
          initiating any paid chat or call session.
        </p>
        <p>
          Consultation fees for chats and calls are deducted from the user's
          wallet balance based on actual usage time.
        </p>
        <p>
          User must maintain a minimum recharge equivalent to 5 minutes of
          consultation in their wallet to initiate chat or call with any
          astrologer.
        </p>

        <strong>8.2 First Recharge 90% Promotional Offer</strong>
        <p>
          AstroBhagya may provide a 90% discount on the first recharge to
          eligible new users, subject to the following conditions:
        </p>
        <ul>
          <li>
            The 90% discount is applicable only on the first successful recharge
            made using a valid promotional code available on the platform at the
            time of recharge.
          </li>
          <li>The minimum recharge amount must be ₹100.</li>
          <li>
            The maximum eligible recharge amount under this offer is ₹500.
          </li>
          <li>
            The promotional discount will not apply to any recharge amount
            exceeding ₹500.
          </li>
          <li>The offer is available only once per user and per account.</li>
          <li>
            Users who delete their account and create a new account (with same
            or different credentials) shall not be eligible to avail the offer
            again.
          </li>
          <li>
            After receiving the discounted recharge benefit, users may utilize
            their wallet balance for both chat and call consultations, subject
            to applicable per-minute charges.
          </li>
          <li>
            The Company reserves the right to modify, suspend, or withdraw the
            promotional offer at its sole discretion without prior notice.
          </li>
          <li>
            Any misuse, fraudulent activity, or attempt to manipulate the
            promotional benefit may result in suspension or termination of the
            user account.
          </li>
        </ul>

        <strong>8.3 Paid Chat &amp; Call Services</strong>
        <ul>
          <li>
            All chats and calls are paid services and require sufficient wallet
            balance prior to initiation.
          </li>
          <li>
            Consultation charges shall be deducted per minute based on the
            astrologer's applicable rate.
          </li>
          <li>
            Calls are chargeable from the start of the consultation and are not
            covered under any free usage unless explicitly stated by the
            platform.
          </li>
        </ul>

        <strong>8.4 Payment Methods</strong>
        <p>
          Payments for Services must be made through the payment methods
          supported by the Platform, such as credit/debit cards, net banking,
          UPI, mobile wallets, or any other online gateway enabled from time to
          time. Cash payments or direct transfers to Astrologers are strictly
          prohibited and may lead to suspension of both User and Astrologer
          accounts.
        </p>

        <strong>8.5 Timing of Charges</strong>
        <p>Depending on the type of Service, Users may be required to:</p>
        <ul>
          <li>
            Prepay: Purchase credits or minutes in advance before starting a
            consultation;
          </li>
          <li>
            Charges are automatically deducted from the User's chosen payment
            method or wallet balance at the end of a session. By using the
            Platform, you authorize AstroBhagya to charge your selected payment
            method for all fees incurred.
          </li>
        </ul>

        <strong>8.6 GST and TDS Deductions</strong>
        <p>
          For Astrologers, payments are made net of applicable taxes. For
          example, GST at 18% and TDS at the prevailing rate will be deducted at
          source before remitting payment to the Astrologer's bank account.
          AstroBhagya will provide invoices and/or payment statements as
          required under Indian tax laws.
        </p>
        <p>
          AstroBhagya is not responsible for any additional taxes, fees, or
          charges levied by banks, credit card issuers, or payment processors.
        </p>

        {/* ───────────────────────── 9 ───────────────────────── */}
        <h5>9. Limitation of Liability / Disclaimers</h5>

        <strong>9.1 No Guarantee of Predictions</strong>
        <p>
          Astrology is an interpretative science and art form. All
          consultations, reports, and remedies offered through the Platform are
          for informational and guidance purposes only. AstroBhagya does not
          guarantee the accuracy, reliability, or effectiveness of any
          prediction, suggestion, or remedy provided by an Astrologer.
        </p>

        <strong>9.2 Not Responsible for Consequences</strong>
        <p>You acknowledge and agree that:</p>
        <ul>
          <li>
            AstroBhagya and its Astrologers are not responsible for any
            financial, medical, legal, emotional, or other consequences arising
            from the use of Services.
          </li>
          <li>
            You are solely responsible for any decisions or actions taken based
            on the advice received from Astrologers.
          </li>
          <li>
            The Platform is not a substitute for professional advice in medical,
            legal, or financial matters.
          </li>
        </ul>

        <strong>9.3 Platform Provided "As-Is"</strong>
        <p>
          The Platform and all Services are provided on an "as-is" and
          "as-available" basis without any warranties of any kind, express or
          implied. Without limiting the foregoing, AstroBhagya disclaims all
          warranties of merchantability, fitness for a particular purpose,
          non-infringement, and any warranties arising from course of dealing or
          usage of trade.
        </p>
        <p>
          AstroBhagya does not warrant that the Platform will be uninterrupted,
          secure, or error-free, or that any defects will be corrected. You
          acknowledge that you use the Platform at your own risk.
        </p>

        <strong>9.4 Limitation of Liability</strong>
        <p>
          To the fullest extent permitted by law, AstroBhagya, its affiliates,
          employees, and Astrologers shall not be liable for any indirect,
          incidental, special, consequential, or punitive damages, including
          loss of profits, data, goodwill, or other intangible losses, resulting
          from:
        </p>
        <ul>
          <li>Your access to or use of the Platform;</li>
          <li>Any advice or content obtained through the Platform;</li>
          <li>
            Unauthorized access to or use of your account or personal data;
          </li>
          <li>Any other matter relating to the Platform or Services.</li>
        </ul>
        <p>
          If AstroBhagya is found liable for any claim, our total liability
          shall not exceed the amount you paid for the Service giving rise to
          the claim.
        </p>

        {/* ───────────────────────── 10 ───────────────────────── */}
        <h5>10. Intellectual Property Rights</h5>

        <strong>10.1 Ownership of Content</strong>
        <p>
          All content, software, source code, user interfaces, designs,
          graphics, logos, trade names, trademarks, service marks and other
          intellectual property displayed on or embodied within the Platform are
          and shall remain the exclusive property of the Company and/or its
          licensors. No right, title or interest in any intellectual property is
          transferred to you by virtue of your access to or use of the Platform.
          All rights not expressly granted are reserved.
        </p>

        <strong>10.2 Licences Granted to Users</strong>
        <p>
          Subject to your compliance with these Terms, the Company grants you a
          limited, non-exclusive, non-transferable, revocable licence to access
          and use the Platform solely for its intended purposes. This licence
          does not permit you to download, copy, reproduce, modify, adapt,
          create derivative works from, publicly display, publicly perform,
          distribute, transmit, broadcast, sell, licence or otherwise exploit
          any portion of the Platform or its content except as expressly
          authorised in writing.
        </p>

        <strong>10.3 Prohibition of Copying or Redistribution</strong>
        <p>
          You must not copy, redistribute, transmit, display, perform,
          reproduce, publish, license, create derivative works from, transfer,
          or sell any information, software, products or services obtained from
          the Platform without prior written consent from the Company.
          Unauthorised use may constitute infringement of copyright, trademark
          and other laws and may give rise to civil and criminal liability.
        </p>

        <strong>10.4 User-Generated Content</strong>
        <p>
          Where you submit, upload or post content to the Platform, you grant
          the Company a worldwide, royalty-free, perpetual, irrevocable,
          non-exclusive licence to use, reproduce, modify, adapt, publish,
          translate, create derivative works from, distribute, perform and
          display such content for the purposes of operating and promoting the
          Platform. You warrant that you own or have the necessary rights to
          grant such licence and that your content does not infringe the rights
          of any third party.
        </p>

        <strong>10.5 Infringement Notices</strong>
        <p>
          If you believe any content on the Platform infringes your intellectual
          property rights, please notify us in writing with sufficient details
          to enable us to investigate and, where appropriate, remove or disable
          access to the infringing content.
        </p>

        {/* ───────────────────────── 11 ───────────────────────── */}
        <h5>11. Privacy and Data Protection</h5>

        <strong>11.1 General</strong>
        <p>
          The Company takes the privacy of its users seriously and complies with
          applicable data protection laws.
        </p>

        <strong>11.2 Data Collected</strong>
        <p>
          We may collect and process the following categories of personal data:
        </p>
        <ul>
          <li>
            Information you provide when registering, creating an account or
            using our services (such as your name, contact details, date of
            birth, documents (if applicable) payment information and
            preferences);
          </li>
          <li>
            Technical data automatically collected from your device (including
            IP address, browser type, operating system, time zone and cookies);
          </li>
          <li>
            Information relating to your transactions and interactions on the
            Platform;
          </li>
          <li>
            Communications you send to us, including customer support requests
            or feedback.
          </li>
        </ul>

        <strong>11.3 How We Use Your Data</strong>
        <p>We process personal data to:</p>
        <ul>
          <li>Provide, maintain and improve the Platform and our services;</li>
          <li>Process payments and fulfil contractual obligations;</li>
          <li>Respond to your enquiries, requests and complaints;</li>
          <li>Send administrative, transactional or service messages;</li>
          <li>Comply with legal obligations and enforce our rights.</li>
        </ul>

        <strong>11.4 Data Storage and Security</strong>
        <p>
          We implement appropriate technical and organisational measures to
          protect personal data against unauthorised or unlawful processing,
          accidental loss, destruction or damage. Personal data is stored on
          secure servers in jurisdictions that maintain adequate data protection
          standards. Where data is transferred across jurisdictions, we ensure
          that suitable safeguards are in place.
        </p>

        <strong>11.5 Retention</strong>
        <p>
          We retain personal data only for as long as necessary to fulfil the
          purposes for which it was collected, or as required by law. Once data
          is no longer needed, it is securely deleted or anonymised.
        </p>

        <strong>11.6 Third-Party Processors</strong>
        <p>
          We may engage trusted third-party service providers to perform certain
          functions on our behalf, such as payment processing, data analytics,
          hosting and customer support. Such providers will only have access to
          the personal data necessary to perform their functions and are bound
          by contractual obligations to keep it secure and use it only in
          accordance with our instructions.
        </p>

        <strong>11.7 Your Rights</strong>
        <p>
          You have rights under data protection laws, including the right to
          access, rectify or erase your personal data, the right to restrict or
          object to processing, the right to data portability, and the right to
          withdraw consent at any time where processing is based on consent. To
          exercise your rights, please contact us at the details provided in our
          Privacy Policy.
        </p>

        <strong>11.8 Reference to Privacy Policy</strong>
        <p>
          Further details regarding how we collect, use and protect your
          personal data can be found in our separate Privacy Policy, which forms
          part of these Terms. By using the Platform, you acknowledge that you
          have read and understood the Privacy Policy.
        </p>

        {/* ───────────────────────── 12 ───────────────────────── */}
        <h5>12. Third-Party Links and Services</h5>

        <strong>12.1 Third-Party Websites</strong>
        <p>
          The Platform may contain links to third-party websites, services or
          resources that are not owned or controlled by the Company. Such links
          are provided for your convenience only. We do not endorse or assume
          any responsibility for the content, privacy policies or practices of
          any third-party websites or services.
        </p>

        <strong>12.2 No Liability</strong>
        <p>
          You acknowledge and agree that the Company shall not be liable,
          directly or indirectly, for any damage or loss caused or alleged to be
          caused by or in connection with the use of or reliance on any content,
          goods or services available on or through such third-party websites or
          services.
        </p>

        <strong>12.3 Third-Party Integrations</strong>
        <p>
          Where the Platform integrates with third-party software, payment
          gateways or other services, your use of those services may be subject
          to the third party's terms and conditions and privacy policies. It is
          your responsibility to review and comply with such terms.
        </p>

        {/* ───────────────────────── 13 ───────────────────────── */}
        <h5>13. Termination of Access</h5>

        <strong>13.1 Suspension or Termination by the Company</strong>
        <p>
          We reserve the right to suspend or terminate your account and/or
          access to the Platform at any time, with or without notice, if we
          reasonably believe that you have breached these Terms, engaged in
          fraudulent or illegal activities, caused harm to other users or to the
          Company, or if required to do so by law or regulatory authorities.
        </p>

        <strong>13.2 Effect of Termination</strong>
        <p>
          Upon termination, your right to access and use the Platform shall
          cease immediately. We may, at our discretion, delete or disable access
          to any of your data or content stored on the Platform. Certain
          provisions of these Terms, including intellectual property rights,
          disclaimers, indemnities and limitations of liability, shall survive
          termination.
        </p>

        <strong>13.3 Remaining Credits and Payments</strong>
        <p>
          Where your account holds unused credits, balances or pre-paid fees at
          the time of termination, the Company will handle such amounts in
          accordance with applicable law and its Refund Policy. In cases of
          termination due to your breach of these Terms or fraudulent activity,
          you may forfeit any such balances. In all other cases, the Company
          will make reasonable efforts to refund unused amounts after deducting
          any outstanding charges or liabilities.
        </p>

        <strong>13.4 Voluntary Closure</strong>
        <p>
          You may close your account at any time by contacting us. Closing your
          account does not relieve you of any obligations incurred prior to
          closure, including payment of any fees due.
        </p>

        {/* ───────────────────────── 14 ───────────────────────── */}
        <h5>14. Indemnification</h5>

        <strong>14.1 User's Obligations</strong>
        <p>
          You agree to defend, indemnify and hold harmless the Company, its
          affiliates, directors, officers, employees, agents, contractors and
          licensors from and against all claims, liabilities, damages, losses,
          costs, expenses or fees (including reasonable legal fees) arising out
          of or relating to:
        </p>
        <ul>
          <li>Your use or misuse of the Platform;</li>
          <li>Your violation of these Terms;</li>
          <li>
            Your infringement of any intellectual property or other right of any
            person or entity;
          </li>
          <li>
            Any content you submit, post or transmit through the Platform.
          </li>
        </ul>

        <strong>14.2 Company's Rights</strong>
        <p>
          We reserve the right, at our own expense, to assume the exclusive
          defence and control of any matter subject to indemnification by you,
          in which case you agree to cooperate with us in asserting any
          available defences.
        </p>

        <strong>14.3 Limitation</strong>
        <p>
          This indemnity does not limit or exclude any liability that cannot be
          limited or excluded under applicable law.
        </p>

        {/* ───────────────────────── 15 ───────────────────────── */}
        <h5>15. Governing Law and Jurisdiction</h5>

        <strong>15.1 Applicable Law</strong>
        <p>
          These Terms and any disputes or claims arising out of or in connection
          with them (including non-contractual disputes or claims) shall be
          governed by and construed in accordance with the laws of England and
          Wales, without regard to its conflict of law provisions.
        </p>

        <strong>15.2 Jurisdiction</strong>
        <p>
          The courts of England and Wales shall have exclusive jurisdiction to
          settle any dispute or claim arising out of or in connection with these
          Terms or their subject matter. However, if you are a consumer resident
          in another country, you may also bring proceedings in your home courts
          under mandatory consumer protection laws.
        </p>

        <strong>15.3 Alternative Dispute Resolution</strong>
        <p>
          We may, at our discretion, offer to resolve disputes through mediation
          or another form of alternative dispute resolution before resorting to
          litigation. Participation in such processes does not affect either
          party's right to commence court proceedings at any time.
        </p>

        <strong>15.4 Severability</strong>
        <p>
          If any provision of these Terms is found by a court or competent
          authority to be invalid or unenforceable, that provision shall be
          deemed modified to the minimum extent necessary to make it valid and
          enforceable, and the remaining provisions shall remain in full force
          and effect.
        </p>

        {/* ───────────────────────── 16 ───────────────────────── */}
        <h5>16. Changes to Terms</h5>

        <strong>16.1 Right to Amend or Update</strong>
        <p>
          The Company reserves the right, at its sole discretion, to amend,
          update or replace any part of these Terms at any time in order to
          reflect changes in law, regulatory requirements, business practices,
          or the scope of services offered on the Platform. Such changes shall
          take effect on the date specified in the updated Terms or, if no date
          is specified, immediately upon publication.
        </p>

        <strong>16.2 Notification of Changes</strong>
        <p>
          We will endeavour to give you reasonable notice of any material
          changes to these Terms. Notification may be provided by one or more of
          the following means:
        </p>
        <ul>
          <li>Posting the updated Terms on the Platform;</li>
          <li>
            Sending an e-mail to the address associated with your account;
          </li>
          <li>
            Displaying a prominent notice or pop-up when you next access the
            Platform;
          </li>
          <li>
            Any other method reasonably designed to bring the changes to your
            attention.
          </li>
        </ul>

        <strong>16.3 User's Responsibility</strong>
        <p>
          It is your responsibility to review the Terms regularly to ensure you
          are aware of the current version. By continuing to access or use the
          Platform after changes have taken effect, you agree to be bound by the
          revised Terms. If you do not agree with the changes, you should
          discontinue use of the Platform and close your account in accordance
          with Clause 14.4.
        </p>

        <strong>16.4 Historical Versions</strong>
        <p>
          The Company may, but is not obliged to, retain and make available
          archived versions of previous Terms for reference. These do not
          constitute a waiver of any rights or obligations under the current
          Terms.
        </p>

        {/* ───────────────────────── 17 ───────────────────────── */}
        <h5>17. Contact Information</h5>

        <strong>17.1 General Enquiries</strong>
        <p>
          If you have any questions, concerns or complaints regarding the
          Platform or these Terms, you may contact us using the details provided
          below. We will make reasonable efforts to respond to enquiries
          promptly and in accordance with applicable consumer protection
          standards.
        </p>

        <strong>17.2 Support E-mail</strong>
        <p>
          For all customer service and support enquiries, please write to{" "}
          <a href="mailto:business@astrobhagya.co.in">
            business@astrobhagya.co.in
          </a>
          . E-mails sent to this address are automatically logged and routed to
          our support team.
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;
